// src/features/counter/counterSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {},
  applications:[]
};
export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
    setUserApplications(state, action) {
      state.applications = action.payload;
    },
  },
});

export const { setUser, setUserApplications } = userSlice.actions;

export default userSlice.reducer;
